export function waTarget(phone) {
  if (!phone) return "";
  let digits = String(phone).replace(/\D+/g, "");
  if (digits.startsWith("00")) digits = digits.slice(2);
  if (digits.startsWith("0")) digits = "90" + digits.slice(1);
  else if (!digits.startsWith("90")) digits = "90" + digits;
  return digits.length >= 12 ? digits : "";
}

